import { useEffect, useState, memo } from 'react'
import styled from 'styled-components'
import { useReplies } from 'querys/comments'
import { TransparentButton } from 'common/button'
import { ArrowBottom, ArrowTop } from 'icons/arrow'
import ReplyDetail from './reply-detail'

const RepliesListStyled = styled.div`
  /* margin: 24px 0; */
  .load-more {
    color: var(--secondary);
    font: 500 16px/24px var(--secondaryFont);
    svg {
      margin-left: 10px;
    }
  }
  .loading {
    font: 500 16px/24px var(--primaryFont);
    color: var(--secondary);
    margin: 16px;
  }
`

function Replies({ parent, replies: count, participants }) {
  const replyQuerys = useReplies(parent)
  const [open, setOpen] = useState(false)
  const { data, isFetching, refetch } = replyQuerys

  useEffect(() => {
    setOpen(true)
  }, [data.length])

  useEffect(() => {
    if (count === 1) {
      setOpen(true)
    }
  }, [count])

  if (data.length === 0) return null
  const handleOpen = () => {
    setOpen(true)
    if (data.length < count) refetch()
  }

  return (
    <RepliesListStyled>
      {(data.length < count || open) && data.map(({ uuid }, idx) => (
        <ReplyDetail
          parent={parent}
          key={uuid}
          commentIdx={idx}
          uuid={uuid}
          participants={participants}
        />
      ))
      }
      {
        isFetching && (
          <p className="loading">Cargando...</p>
        )
      }
      {
        (!open || data.length < count) ? (
          <TransparentButton className="load-more" onClick={() => handleOpen()}>
            Ver mas respuestas
            <ArrowBottom color="var(--secondary)" />
          </TransparentButton>
        ) : (
          <TransparentButton className="load-more" onClick={() => setOpen(false)}>
            Ocultar respuestas
            <ArrowTop color="var(--secondary)" />
          </TransparentButton>
        )
      }
    </RepliesListStyled>
  )
}

const RepliesMemo = memo(Replies)

export default RepliesMemo
